import React, { useRef, useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import { DASHBOARD_WIDGETS } from "./DashboardWidgets";
import Dialog from "@mui/material/Dialog";
import {
  DashboardLayoutComponent,
  PanelDirective,
  PanelsDirective,
} from "@syncfusion/ej2-react-layouts";
import DashboardProjectMetrics from "./DashboardProjectMetrics_sfgrid";
import DashboardTasksContainer from "./DashboardTasksContainer";
import DashboardRAIDContainer from "./DashboardRAIDContainer";
import DashboardProjectLinksContainer from "./DashboardProjectLinksContainer";
import DashboardProjectDocumentsContainer from "./DashboardProjectDocumentsContainer";
import DashboardProjectDocuments from "./DashboardProjectDocuments_sfgrid";
import DashboardProjectDocumentsGDrive from "./DashboardProjectDocuments_gdrive";
import DashboardNotesContainer from "./DashboardNotesContainer";
import DashboardProjectTeam from "./DashboardProjectTeam_sfgrid";
import DashboardProjectMetricsBar from "./DashboardProjectMetricsBar";
import DashboardProjectMetricsBigNumbers from "./DashboardProjectMetricsBigNumbers";
import DashboardProjectHealth from "./DashboardProjectHealth";
import DashboardTextboxContainer from "./DashboardTextboxContainer";
import { CredsContext, HelpModeContext } from "./Contexts";
import { STORAGE_OPTIONS } from "./GlobalSettingsList";
import "./styles/DashboardSingleProject_nogrid.css";
import ProjectTitleBar from "./ProjectTitleBar_ably";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Tools from "./JNSTools";
import StatusReportContainer from "./StatusReportContainer";

function DashboardSingleProject_nogrid(props) {
  const panelMasterArray = useRef([]);
  const projectObject = useRef(
    JSON.parse(sessionStorage.getItem("projectObject")),
  );
  const [panelsLocked, setPanelsLocked] = useState(
    (sessionStorage.getItem("panelsLocked") || "true") == "true" ? true : false,
  );
  const [statusReportVisibility, setStatusReportVisibility] = useState(false);
  const dbConfigStorage = sessionStorage.getItem("dashboardConfig");
  const [dashboardConfig_nogrid, setDashboardConfig_nogrid] = useState(
    dbConfigStorage && dbConfigStorage != "[]"
      ? JSON.parse(dbConfigStorage)
      : [],
  );
  const [dirty, isDirty] = useState(false);
  const dlcRef = useRef();
  const DASHBOARD_LAYOUT_COLUMNS = 10;
  const creds = useContext(CredsContext).creds;
  const authString = Tools.getXmlBodyAuthString(creds);
  const urlString = Tools.getInstanceUrl(creds);
  const loadCompleted = useRef(false);

  //localStorage.removeItem("DashboardLayoutdefaultLayout");

  console.log("panels: " + JSON.stringify(dashboardConfig_nogrid));

  /*useEffect(() => {
    if (dlcRef.current) {
      const s = dlcRef.current.serialize();
      console.log("Serialized DLC: " + JSON.stringify(s));
      //console.log(JSON.stringify(dashboardConfig_nogrid));
    }
  }, []);*/

  const cellSpacing = [10, 10];

  function addPanel(panelId) {
    const defaultSize = panelMasterArray.current.find(
      (elem) => elem.id == panelId,
    ).defaultSize;

    const serializedDLC =
      dashboardConfig_nogrid.length > 0
        ? JSON.parse(JSON.stringify(dlcRef.current.serialize()))
        : [];
    const cellPopulated = Array(200).fill(false);

    for (let i = 0; i < serializedDLC.length; i++) {
      const elemRow = serializedDLC[i].row;
      const elemCol = serializedDLC[i].col;
      const sizeX = serializedDLC[i].sizeX;
      const sizeY = serializedDLC[i].sizeY;

      for (let yCounter = 0; yCounter < sizeY; yCounter++) {
        for (let xCounter = 0; xCounter < sizeX; xCounter++) {
          const cellIndex =
            (yCounter + elemRow) * DASHBOARD_LAYOUT_COLUMNS +
            (xCounter + elemCol);
          //console.log("CI: " + cellIndex);
          cellPopulated[cellIndex] = true;
        }
      }
    }

    let cellCounter = 0;
    let locationFound = false;

    while (cellCounter < cellPopulated.length - defaultSize && !locationFound) {
      let emptyCells = 0;
      for (let j = cellCounter; j < cellCounter + defaultSize; j++) {
        if (!cellPopulated[j]) {
          emptyCells++;
          if (emptyCells == defaultSize && !locationFound) {
            if (
              parseInt(j / DASHBOARD_LAYOUT_COLUMNS) ==
              parseInt(cellCounter / DASHBOARD_LAYOUT_COLUMNS)
            ) {
              locationFound = true;
            }
          }
        } else {
          emptyCells = 0;
        }
      }

      cellCounter++;
    }

    if (cellCounter > 0) {
      cellCounter--;
    }
    //console.log("cellCounter: " + cellCounter);
    const panelString =
      '{"id":"widget_' +
      panelId +
      '","row":' +
      parseInt(cellCounter / DASHBOARD_LAYOUT_COLUMNS) +
      ',"col":' +
      (cellCounter % DASHBOARD_LAYOUT_COLUMNS) +
      ',"sizeX":' +
      defaultSize +
      ',"sizeY":1,"minSizeX":1,"minSizeY":1,"maxSizeX":null,"maxSizeY":null}';
    console.log("PanelString: " + panelString);
    const newArray = [...serializedDLC];
    newArray.push(JSON.parse(panelString));

    const prefId = sessionStorage.getItem("dashboardConfigPrefRecord");
    const updateString =
      authString +
      '<Modify type="Preference"><Preference><id>' +
      prefId +
      "</id><setting>" +
      JSON.stringify(newArray) +
      "</setting></Preference></Modify></request>";
    Tools.fetchPost(updateString, urlString);

    sessionStorage.setItem("dashboardConfig", JSON.stringify(newArray));

    setDashboardConfig_nogrid(newArray);
    /*window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth", // Optional: Adds smooth scrolling animation
    });*/
  }

  function removePanel(event) {
    const panelIndex = dashboardConfig_nogrid.findIndex(
      (elem) => elem.id == "widget_" + event.currentTarget.id,
    );
    const newArray = dashboardConfig_nogrid.toSpliced(panelIndex, 1);
    //dlcRef.current.removePanel("widget_" + event.currentTarget.id);
    if (newArray.length > 0) {
      sessionStorage.setItem("dashboardConfig", JSON.stringify(newArray));
    } else {
      //dlcRef.current.removeAll();
      sessionStorage.removeItem("dashboardConfig");
    }

    const prefId = sessionStorage.getItem("dashboardConfigPrefRecord");
    const updateString =
      authString +
      '<Modify type="Preference"><Preference><id>' +
      prefId +
      "</id><setting>" +
      JSON.stringify(newArray) +
      "</setting></Preference></Modify></request>";
    Tools.fetchPost(updateString, urlString);
    setDashboardConfig_nogrid(newArray);
    isDirty(!dirty);
  }

  function refreshDashboard() {
    isDirty(!dirty);
  }

  const saveConfig = () => {
    if (dlcRef.current) {
      const s = dlcRef.current.serialize();
      //console.log(JSON.stringify(s));
      const prefId = sessionStorage.getItem("dashboardConfigPrefRecord");
      const updateString =
        authString +
        '<Modify type="Preference"><Preference><id>' +
        prefId +
        "</id><setting>" +
        JSON.stringify(s) +
        "</setting></Preference></Modify></request>";
      Tools.fetchPost(updateString, urlString);
      sessionStorage.setItem("dashboardConfig", JSON.stringify(s));
    }
  };

  const handleCloseStatusReport = (event) => {
    setStatusReportVisibility(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      props.waitHandler(true);
      const dbValue = await establishDashboardConfiguration(
        projectObject.current,
        creds,
      );
      sessionStorage.setItem("dashboardConfig", JSON.stringify(dbValue));
      setDashboardConfig_nogrid(dbValue);
      loadCompleted.current = true;
      props.waitHandler(false);
    };

    const dbConfig = sessionStorage.getItem("dashboardConfig");
    if (!dbConfig) {
      fetchData();
    }

    /*if (dlcRef.current) {
      const s = dlcRef.current.serialize();
      console.log("destroyed: " + JSON.stringify(s));
      sessionStorage.setItem("dashboardConfig", JSON.stringify(s));
      setDashboardConfig_nogrid(s);
    }*/
  }, []);

  panelMasterArray.current = populatePanelMasterArray(
    props,
    panelsLocked,
    removePanel,
    projectObject,
    props.waitHandler,
    refreshDashboard,
    creds,
  );

  return (
    <div style={{ minWidth: "1536px" }}>
      {/* prob should be 1920, scaled down to 1536 */}
      <div className="control-section">
        <Box display="flex">
          <ProjectTitleBar
            top={0}
            docPage="DASHBOARD TAB.pdf"
            setPanelsLocked={setPanelsLocked}
            addPanel={addPanel}
            setStatusReportVisibility={setStatusReportVisibility}
          />
        </Box>
        <p style={{ lineHeight: 0.6 }}>&nbsp;</p>
        <Box
          sx={{
            backgroundColor: "transparent",
            marginLeft: "10px",
            marginRight: "10px",
          }}
        >
          <DashboardLayoutComponent
            id="defaultLayout"
            cellSpacing={cellSpacing}
            showGridLines={!panelsLocked}
            allowDragging={!panelsLocked}
            allowResizing={!panelsLocked}
            enablePersistence={false}
            allowFloating={panelsLocked}
            columns={DASHBOARD_LAYOUT_COLUMNS}
            ref={(dlc) => (dlcRef.current = dlc)}
            resizeStop={saveConfig}
            dragStop={saveConfig}
            sx={{ backgroundColor: "transparent" }}
          >
            <PanelsDirective>
              {dashboardConfig_nogrid.map((panel) => (
                <PanelDirective
                  id={panel.id}
                  key={panel.id}
                  sizeX={panel.sizeX}
                  sizeY={panel.sizeY}
                  row={panel.row}
                  col={panel.col}
                  content={
                    panelMasterArray.current.find(
                      (panelElem) => panel.id == "widget_" + panelElem.id,
                    ).content
                  }
                />
              ))}
            </PanelsDirective>
          </DashboardLayoutComponent>
        </Box>
      </div>
      <Dialog open={statusReportVisibility} fullScreen>
        <StatusReportContainer
          panelArray={panelMasterArray.current}
          handleClose={handleCloseStatusReport}
        />
      </Dialog>
    </div>
  );
}

function populatePanelMasterArray(
  props,
  locked,
  removePanel,
  projectObject,
  waitHandler,
  refreshDashboard,
  creds,
) {
  // first check for dashboardConfig preference/sessionStorage

  const storageOption =
    localStorage.getItem(creds.company + "|StorageOption") ||
    STORAGE_OPTIONS[0];

  const panelArray = [
    {
      id: 1,
      defaultSize: 3,
      content: function () {
        return (
          <DashboardProjectLinksContainer
            projectObject={projectObject.current}
            waitHandler={waitHandler}
            panelLocked={locked}
            removePanel={removePanel}
            panelId={1}
          />
        );
      },
      statusContent: function (index) {
        return null;
      },
    },
    {
      id: 3,
      defaultSize: 3,
      content: function () {
        //if (storageOption == "OpenAir Workspace") {
        return (
          <DashboardProjectDocumentsContainer
            projectObject={projectObject.current}
            waitHandler={waitHandler}
            panelLocked={locked}
            removePanel={removePanel}
            panelId={3}
          />
        );
        //} else {
        //  return (
        //    <DashboardProjectDocumentsGDrive
        //      projectObject={projectObject.current}
        //      waitHandler={props.waitHandler}
        //      panelLocked={locked}
        //      removePanel={removePanel}
        //      panelId={3}
        //    />
        //  );
        //}
      },
      statusContent: function () {
        return null;
      },
    },
    {
      id: 4,
      defaultSize: 3,
      content: function () {
        /*return (
          <DashboardNotesContainer
            panelLocked={locked}
            removePanel={removePanel}
            panelId={4}
          />
        );*/
        return (
          <DashboardTextboxContainer
            projectObject={projectObject.current}
            waitHandler={props.waitHandler}
            statusVersion={false}
          />
        );
      },
      statusContent: function () {
        return (
          <DashboardTextboxContainer
            projectObject={projectObject.current}
            waitHandler={props.waitHandler}
            statusVersion={true}
          />
        );
      },
    },
    {
      id: 5,
      defaultSize: 6,
      content: function () {
        return (
          <DashboardProjectMetricsBigNumbers
            projectObject={projectObject.current}
            metric="hours"
            panelLocked={locked}
            removePanel={removePanel}
            panelId={5}
            statusVersion={false}
          />
        );
      },
      statusContent: function () {
        return (
          <DashboardProjectMetricsBigNumbers
            projectObject={projectObject.current}
            metric="hours"
            panelLocked={locked}
            removePanel={removePanel}
            panelId={5}
            statusVersion={true}
          />
        );
      },
    },
    {
      id: 6,
      defaultSize: 3,
      content: function () {
        return (
          <DashboardProjectMetricsBar
            projectObject={projectObject.current}
            metric="hours"
            panelLocked={locked}
            removePanel={removePanel}
            panelId={6}
          />
        );
      },
      statusContent: function () {
        return <div>Foo6</div>;
      },
    },
    {
      id: 7,
      defaultSize: 3,
      content: function () {
        return (
          <DashboardProjectMetrics
            projectObject={projectObject.current}
            panelLocked={locked}
            removePanel={removePanel}
            panelId={7}
          />
        );
      },
      statusContent: function () {
        return <div>Foo7</div>;
      },
    },
    {
      id: 8,
      defaultSize: 2,
      content: function () {
        return (
          <DashboardProjectHealth
            projectObject={projectObject.current}
            waitHandler={waitHandler}
            metric="SPI"
            panelLocked={locked}
            removePanel={removePanel}
            panelId={8}
            statusVersion={false}
          />
        );
      },
      statusContent: function () {
        return (
          <DashboardProjectHealth
            projectObject={projectObject.current}
            waitHandler={waitHandler}
            metric="SPI"
            panelLocked={locked}
            removePanel={removePanel}
            panelId={8}
            statusVersion={true}
          />
        );
      },
    },
    {
      id: 9,
      defaultSize: 2,
      content: function () {
        return (
          <DashboardProjectHealth
            projectObject={projectObject.current}
            waitHandler={waitHandler}
            metric="CPI-H"
            panelLocked={locked}
            removePanel={removePanel}
            panelId={9}
            statusVersion={false}
          />
        );
      },
      statusContent: function () {
        return (
          <DashboardProjectHealth
            projectObject={projectObject.current}
            waitHandler={waitHandler}
            metric="CPI-H"
            panelLocked={locked}
            removePanel={removePanel}
            panelId={9}
            statusVersion={true}
          />
        );
      },
    },
    {
      id: 10,
      defaultSize: 5,
      content: function () {
        return (
          <DashboardProjectTeam
            projectObject={projectObject.current}
            includeRole={true}
            includeLastView={true}
            waitHandler={props.waitHandler}
            panelLocked={locked}
            removePanel={removePanel}
            panelId={10}
            refreshDashboard={refreshDashboard}
            statusVersion={false}
          />
        );
      },
      statusContent: function () {
        return (
          <DashboardProjectTeam
            projectObject={projectObject.current}
            includeRole={true}
            includeLastView={true}
            waitHandler={props.waitHandler}
            panelLocked={locked}
            removePanel={removePanel}
            panelId={10}
            refreshDashboard={refreshDashboard}
            statusVersion={true}
          />
        );
      },
    },
    {
      id: 11,
      defaultSize: 3,
      content: function () {
        return (
          <DashboardProjectTeam
            projectObject={projectObject.current}
            includeRole={true}
            includeLastView={false}
            waitHandler={props.waitHandler}
            panelLocked={locked}
            removePanel={removePanel}
            panelId={11}
          />
        );
      },
      statusContent: function () {
        return <div>Foo11</div>;
      },
    },
    {
      id: 12,
      defaultSize: 3,
      content: function () {
        return (
          <DashboardProjectTeam
            projectObject={projectObject.current}
            includeRole={false}
            includeLastView={true}
            waitHandler={props.waitHandler}
            panelLocked={locked}
            removePanel={removePanel}
            panelId={12}
          />
        );
      },
      statusContent: function () {
        return <div>Foo12</div>;
      },
    },
    {
      id: 13,
      defaultSize: 3,
      content: function () {
        return (
          <DashboardTasksContainer
            projectObject={projectObject.current}
            panelLocked={locked}
            removePanel={removePanel}
            panelId={13}
            statusVersion={false}
          />
        );
      },
      statusContent: function () {
        return (
          <DashboardTasksContainer
            projectObject={projectObject.current}
            panelLocked={locked}
            removePanel={removePanel}
            panelId={13}
            statusVersion={true}
          />
        );
      },
    },
    {
      id: 14,
      defaultSize: 4,
      content: function () {
        return (
          <DashboardRAIDContainer
            projectObject={projectObject.current}
            panelLocked={locked}
            removePanel={removePanel}
            panelId={14}
            raidType="risk"
            statusVersion={false}
          />
        );
      },
      statusContent: function (index) {
        return (
          <DashboardRAIDContainer
            projectObject={projectObject.current}
            panelLocked={locked}
            removePanel={removePanel}
            panelId={14}
            raidType="risk"
            statusVersion={true}
          />
        );
      },
    },
    {
      id: 15,
      defaultSize: 4,
      content: function () {
        return (
          <DashboardRAIDContainer
            projectObject={projectObject.current}
            panelLocked={locked}
            removePanel={removePanel}
            panelId={15}
            raidType="action"
            statusVersion={false}
          />
        );
      },
      statusContent: function (index) {
        return (
          <DashboardRAIDContainer
            projectObject={projectObject.current}
            panelLocked={locked}
            removePanel={removePanel}
            panelId={14}
            raidType="action"
            statusVersion={true}
          />
        );
      },
    },
    {
      id: 16,
      defaultSize: 4,
      content: function () {
        return (
          <DashboardRAIDContainer
            projectObject={projectObject.current}
            panelLocked={locked}
            removePanel={removePanel}
            panelId={16}
            raidType="issue"
            statusVersion={false}
          />
        );
      },
      statusContent: function (index) {
        return (
          <DashboardRAIDContainer
            projectObject={projectObject.current}
            panelLocked={locked}
            removePanel={removePanel}
            panelId={16}
            raidType="issue"
            statusVersion={true}
          />
        );
      },
    },
    {
      id: 17,
      defaultSize: 4,
      content: function () {
        return (
          <DashboardRAIDContainer
            projectObject={projectObject.current}
            panelLocked={locked}
            removePanel={removePanel}
            panelId={17}
            raidType="decision"
            statusVersion={false}
          />
        );
      },
      statusContent: function (index) {
        return (
          <DashboardRAIDContainer
            projectObject={projectObject.current}
            panelLocked={locked}
            removePanel={removePanel}
            panelId={17}
            raidType="decision"
            statusVersion={true}
          />
        );
      },
    },
  ];

  return panelArray;
}

async function establishDashboardConfiguration(projectObject, creds) {
  const dbConfig = sessionStorage.getItem("dashboardConfig");
  let returnArray;
  if (!dbConfig || dbConfig === null) {
    const authString = Tools.getXmlBodyAuthString(creds);
    const urlString = Tools.getInstanceUrl(creds);
    const requestString =
      authString +
      '<Read type="Preference" method="equal to" limit="1"><Preference><group_name>oadaSettings</group_name><name>dashboardConfig_' +
      projectObject.id +
      "</name><userid>" +
      creds.id +
      "</userid></Preference></Read></request>";
    const prefRecXml = await Tools.fetchPost(
      requestString,
      urlString,
      "Preference",
    );

    const prefRec = Tools.xmlToArray(prefRecXml.xml);

    if (!prefRec[0]) {
      const addString =
        authString +
        '<Add type="Preference"><Preference><group_name>oadaSettings</group_name><userid>' +
        creds.id +
        "</userid><name>dashboardConfig_" +
        projectObject.id +
        "</name></Preference></Add></request>";
      const addStringResponse = await Tools.fetchPost(
        addString,
        urlString,
        "Preference",
      );
      const newPrefRec = Tools.xmlToArray(addStringResponse.xml);
      sessionStorage.setItem("dashboardConfigPrefRecord", newPrefRec[0].id);
      returnArray = [
        {
          id: "widget_10",
          row: 0,
          col: 0,
          sizeX: 5,
          sizeY: 1,
          minSizeX: 1,
          minSizeY: 1,
          maxSizeX: null,
          maxSizeY: null,
        },
      ];
      sessionStorage.setItem("dashboardConfig", JSON.stringify(returnArray));
      return returnArray;
    } else {
      sessionStorage.setItem("dashboardConfigPrefRecord", prefRec[0].id);
      returnArray = prefRec[0].setting
        ? JSON.parse(prefRec[0].setting)
        : [
            {
              id: "widget_10",
              row: 0,
              col: 0,
              sizeX: 5,
              sizeY: 1,
              minSizeX: 1,
              minSizeY: 1,
              maxSizeX: null,
              maxSizeY: null,
            },
          ];
      sessionStorage.setItem("dashboardConfig", JSON.stringify(returnArray));
      return returnArray;
    }
  }
}

export default DashboardSingleProject_nogrid;

DashboardSingleProject_nogrid.propTypes = {
  waitHandler: PropTypes.func,
};
/*
{dashboardConfig_nogrid.length === 0 &&
          loadCompleted.current === true ? (
            <Box
              sx={{
                backgroundColor: "yellow",
                fontSize: "larger",
                padding: "10px",
              }}
            >
              <span>
                You do not have any dashboard panels selected. Use the lock
                button&nbsp;
              </span>
              <LockIcon />
              <span>&nbsp;in the project title bar to add panels.&nbsp;</span>
              <NorthEastIcon />
            </Box>
          ) : null}*/
